import React from 'react';

function BtcCounsellorSelector({
  t,
  showBtcGuidedHighlight,
  isBtcDropdownOpen,
  setIsBtcDropdownOpen,
  btcDropdownRef,
  selectedBtcCounsellor,
  btcCounsellorOptions,
  clientModeCounsellorMode,
  onClientModeCounsellorModeChange,
  WheelArrowUp,
  WheelArrowDown,
  selectorLabel = 'Select A Counsellor',
  inlineLabel = 'Counsellor:',
  ariaLabel = 'Virtual Counsellor',
}) {
  return (
    <div className="client-selector">
      {selectorLabel && <label className="selector-label">{selectorLabel}</label>}

      <div
        className={`client-wheel-picker${showBtcGuidedHighlight ? ' client-selection-cue' : ''}`}
      >
        <div className="wheel-inline-row">
          <span className="wheel-inline-label">{inlineLabel}</span>
          <div className="wheel-horizontal-control" role="group" aria-label={ariaLabel}>
            <div className="oars-skill-dropdown btc-counsellor-dropdown" ref={btcDropdownRef}>
              <div
                className={`wheel-window oars-dropdown-trigger btc-dropdown-trigger${isBtcDropdownOpen ? ' open' : ''}`}
                onClick={() => setIsBtcDropdownOpen((prev) => !prev)}
                tabIndex={0}
                role="button"
                aria-haspopup="listbox"
                aria-expanded={isBtcDropdownOpen}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setIsBtcDropdownOpen((prev) => !prev);
                  }
                }}
                data-guided-highlight-purpose={showBtcGuidedHighlight ? 'Choose which virtual counsellor will lead the session.' : undefined}
              >
                <span className="wheel-window-number">{selectedBtcCounsellor?.shortLabel || '--'}</span>
                <div className="wheel-scroll-track" aria-hidden="true">
                  <div className="oars-dropdown-arrow">
                    {isBtcDropdownOpen ? <WheelArrowUp /> : <WheelArrowDown />}
                  </div>
                </div>
              </div>
              {isBtcDropdownOpen && (
                <div className="oars-skill-dropdown-menu btc-counsellor-dropdown-menu" role="listbox">
                  {btcCounsellorOptions.map((option) => (
                    <button
                      key={option.value}
                      type="button"
                      role="option"
                      aria-selected={clientModeCounsellorMode === option.value}
                      className={`oars-skill-dropdown-option${clientModeCounsellorMode === option.value ? ' selected' : ''}`}
                      onClick={() => {
                        onClientModeCounsellorModeChange && onClientModeCounsellorModeChange(option.value);
                        setIsBtcDropdownOpen(false);
                      }}
                    >
                      <span className="oars-skill-dropdown-option-letter">{option.shortLabel}</span>
                      {t(option.labelKey)}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BtcCounsellorSelector;
